export const initialState = {
    dialogs: {
        deleteConfirm: false,
        addConfirm: false,
        selectedRecord: null,
    },
    forms: {
        addTemplateForm: {
            templateName: "",
            templateFile: null,
        },
    },
    loading: {
        isLoadingBackdrop: false,
        isBackgroundRefreshing: false,
    },
    table: {
        searchInput: "",
        currentPage: 1,
        recordsPerPage: 10,
    },
};

export function manageTemplatesReducer(state, action) {
    switch (action.type) {
        case "OPEN_DELETE_DIALOG":
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    deleteConfirm: true,
                    selectedRecord: action.payload,
                },
            };

        case "CLOSE_DELETE_DIALOG":
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    deleteConfirm: false,
                    selectedRecord: null,
                },
            };

        case "OPEN_ADD_DIALOG":
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    addConfirm: true,
                },
            };

        case "CLOSE_ADD_DIALOG":
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    addConfirm: false,
                },
                forms: {
                    ...state.forms,
                    addTemplateForm: {
                        templateName: "",
                        templateFile: null,
                    },
                },
            };

        case "UPDATE_FORM_FIELD":
            return {
                ...state,
                forms: {
                    ...state.forms,
                    [action.payload.formName]: {
                        ...state.forms[action.payload.formName],
                        [action.payload.fieldName]: action.payload.value,
                    },
                },
            };

        case "SET_LOADING":
            return {
                ...state,
                loading: {
                    ...state.loading,
                    [action.payload.key]: action.payload.value,
                },
            };

        case "SET_SEARCH_INPUT":
            return {
                ...state,
                table: { ...state.table, searchInput: action.payload, currentPage: 1 },
            };

        case "SET_CURRENT_PAGE":
            return {
                ...state,
                table: { ...state.table, currentPage: action.payload },
            };

        default:
            return state;
    }
}
